/**
 * Where a buyer's upload (`file`) or picked product photo (`productImage`)
 * lives, or null when the stored value is not an object in our own bucket.
 * The buyer supplies it, so it is never trusted as a URL: an absolute one would
 * have "Файл харах" open a page of the buyer's choosing for whoever looks the
 * order up, and the thumbnails fetch from the buyer's host. formatImageURL
 * passes absolute URLs through, which is why order answers do not use it.
 *
 * A bare object name goes under uploads/; anything carrying a scheme has to be
 * under the bucket already. The check runs on the PARSED url, not the string:
 * '..', '%2e%2e' and a backslash are all path steps to a browser, so a prefix
 * test on the raw value lets 'uploads/../../other-bucket/x' through.
 *
 * Mirrors uploadURL in vendor/lib/customFields.ts and backend/lib/customFields.js.
 * The backend rejects such values on new orders; this covers the rows written
 * before it did.
 */
export function uploadURL(value: unknown): string | null {
  if (typeof value !== 'string' || !value || !process.env.NEXT_PUBLIC_BUCKET) return null
  try {
    const root = new URL(process.env.NEXT_PUBLIC_BUCKET).href.replace(/\/*$/, '/')
    // Browsers ignore whitespace and control characters, so "\tjavascript:" is still a scheme.
    const compact = value.replace(/[\u0000-\u0020]/g, '')
    const absolute = /^[a-z][a-z0-9+.-]*:/i.test(compact) || /^[\\/]{2}/.test(compact)
    const folder = absolute ? root : `${root}uploads/`
    const url = new URL(absolute ? value : folder + value.replace(/^\/+/, ''))
    return url.href.startsWith(folder) ? url.href : null
  } catch {
    return null
  }
}
